import { Reducer } from 'redux';
import ActionTypes, { TCerteficateState } from './types';

export const initialState: TCerteficateState = {
  error: null,
  loading: false,
  data: null,
};

const reducer: Reducer<TCerteficateState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CERTEFICATE_R:
    case ActionTypes.UPDATE_CERTEFICATE_R:
      return { ...state, loading: true, error: null };

    case ActionTypes.SET_CERTEFICATE:
      return {
        ...state,
        data: state.data ? { ...state.data, certeficate: action.payload } : { certeficate: action.payload },
        loading: false,
        error: null,
      };

    case ActionTypes.GET_CERTEFICATE_S:
      return { ...state, data: action.payload, loading: false, error: null };

    case ActionTypes.UPDATE_CERTEFICATE_S:
      return {
        ...state,
        data: state.data ? { ...state.data, entity: action.payload } : { entity: action.payload },
        loading: false,
        error: null,
      };
    case ActionTypes.UPDATE_CERTEFICATE_PROFILE_S:
      return {
        ...state,
        data: state.data ? { ...state.data, certeficate: action.payload } : { certeficate: action.payload },
        loading: false,
        error: null,
      };

    case ActionTypes.GET_CERTEFICATE_E:
    case ActionTypes.UPDATE_CERTEFICATE_E:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as CerteficateReducer };
